<template>
  <div>
      <nav class="navbar navbar-expand-lg bg-body-tertiary" style="background-color: white;">
        <!--Search Menu-->
        <div class="container-fluid" style="padding: 5px;">
          <div class="col-8">
            <div class="input-group">
              <span class="input-group-text" id="addon-wrapping" style="border-color: #ddd;
                    background-color: transparent;
                    border-right: 0px;"><i class="nav-icon fa fa-search"></i></span>
              <input type="text" class="form-control bg-light" :placeholder="$t('search')" @change="SearchItem"
                style="border-left: 0px;padding:5px;margin-left: -7px;border-color: #ddd;background-color: transparent !important;">
            </div>
          </div>
          <div class="col-4">
            <div class="col-12 text-right">
              {{ this.currentDate() }}</div>
          </div>
        </div>
        <!--End Search Menu-->
      </nav>
      <div class="container-fluid mt-2">
        <div class="row">
          <!--List Menu-->
          <div class="col-9">
            <div class="mb-4">
              <div class="row">
                <div class="col-2">
                  <div class="card ml-5 ml-md-3 ml-lg-0 mb-0 cursor" @click="onLoad(-99)" style="width: 100%;height: 100%;"
                    :class="isAllCategory === true ? 'activeMenuPOS' : ''">
                    <div class=" text-center mt-2">
                      <p class="h6 font-weight-bold">
                        All
                      </p>
                    </div>
                    <div class="p-0 text-center m-auto">
                      ({{ listMenu.length + 'items' }})
                    </div>
                  </div>
                </div>
                <div class="col-10">
                  <div class="px-0">
                    <VueSlickCarousel v-if="list_categories.length" v-bind="settings" class="custom-slick">
                      <div
                          v-for="category in list_categories"
                          :key="category.id"
                      >
                      <!-- :style="{ width: calculateCardWidth(category.Name) }" -->
                        <div class="d-flex align-items-center flex-row bg-white rounded-lg p-1" :class="category.Active === true ? 'card cursor mb-0 activeMenuPOS ml-5 ml-md-3 ml-lg-0 mb-0' : 'card cursor ml-5 ml-md-3 ml-lg-0 mb-0'"
                             @click="onclickActiveCard(category.Id)"
                             style="width: 100%; height: 100%;"
                            >
                          <div class="mx-2 w-h-25">
                            <img 
                              :src="category.Image ? $base() + 'image/categories/' + category.Image : '/img/no-image.svg'" 
                              class="img-thumbnail m-auto"
                            >
                          </div>
                          <div class="d-flex flex-column flex-grow-1">
                            <div class=" text-center mt-2">
                              <p class="h6 font-weight-bold">
                                {{ category.Name }}
                              </p>
                            </div>
                            <div class="p-0 text-center m-auto">
                              ({{ category.ItemCount + ' Items' }})
                            </div>
                          </div>
                        </div>
                      </div>
                    </VueSlickCarousel>
                  </div>
                </div>
              </div>
            </div>
            <div class="scroll-card">
<!--              <div class="row mr-2">-->
<!--                <div v-for="Menu in listMenuSelected" class="col-12 col-md-6 col-lg-3 p-0 cursor list-menu" :key="Menu.Id">-->
<!--                  <div class="d-flex flex-column bg-white rounded-lg mb-3 p-2" style="gap: 0.1rem;">-->
<!--                    <img-->
<!--                        :src="(Menu.Image !== '' && Menu.Image !== null) ? $base() + 'image/items/' + Menu.Image : '/img/no-image.svg'"-->
<!--                        class="img-thumbnail m-auto"-->
<!--                        style="width: 75px; height: 75px;"-->
<!--                    >-->
<!--                    <div class="text-center">-->
<!--                      <div class="title">-->
<!--                        {{ Menu.Name }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="text-center">-->
<!--                      ${{ Menu.Price }}-->
<!--                    </div>-->
<!--                    <div class="d-flex justify-content-center align-center mt-1">-->
<!--                      <button v-on:click="onclickAdd(Menu.Id)" class="plus">+</button>-->
<!--                      <div class="qty-display mx-2">{{ Menu.Qty }}</div>-->
<!--                      <button v-on:click="onclickMinus(Menu.Id)" class="minus">-</button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

              <div class="row mr-2">
                <div v-for="Menu in listMenuSelected" class="col-12 col-md-6 col-lg-2 p-0 cursor list-menu" :key="Menu.Id">
                  <div class="d-flex flex-column bg-white rounded-lg mb-3 p-2" style="gap: 0.1rem;">
                    <img
                        :src="(Menu.Image !== '' && Menu.Image !== null) ? $base() + 'image/items/' + Menu.Image : '/img/no-image.svg'"
                        class="img-thumbnail m-auto"
                        style="width: 75px; height: 75px;"
                    >
                    <div class="text-center">
                      <div class="title">
                        {{ Menu.Name }}
                      </div>
                    </div>
                    <div class="text-center">
                      ${{ Menu.Price }}
                    </div>
                    <div class="d-flex justify-content-center align-center mt-1">
                      <button v-on:click="onclickAdd(Menu.Id)" class="plus">+</button>
                      <div class="qty-display mx-2">{{ Menu.Qty }}</div>
                      <button v-on:click="onclickMinus(Menu.Id)" class="minus">-</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--End List Menu-->
          <div class="col-3 p-0">
            <div class="card" style="margin-bottom: 0px;height: 100%;">
              <div class="card" style="border: none;margin: 0px;font-size: 16px;">
                <div class="form-group p-2" :class="{ 'form-group-error': '' }">
                  <label class="label-control black">{{ $t("customer") }}</label>
                  <div>
                    <CustomerDropdown ref="customerDropdown" :generalCustomerName="customerName" @select="customerSelected" :v-add-new="false" style="color: black;" />
                  </div>
                </div>
              </div>
              <div class="card h-100" style="border: none;margin: 0px;">
                <div class="menu rounded-0 p-2">
                  <template v-for="menu in listMenu">
                    <template v-if="menu.Qty >= 1">
                      <div class="card test border py-2 mb-1" :key="menu.Id">
                        <div class="row">
                          <div class="col-7" >
                            <div class="row">
                              <div class="col-12" style="margin: auto;">
                                <div class="col-12">
                                  <div class="title" style="font-weight: bold;font-size: 16px;">{{ menu.Name }}</div>
                                </div>
                                <div class="col-12">
                                  <div class="d-flex justify-content-start mt-2 align-center">
                                    <button 
                                    v-on:click="onclickAdd(menu.Id)" 
                                    class="d-flex align-center border-0" 
                                    style="height:20px; width: 34px; color: white;background-color: #00406b;"
                                    >+</button>
                                    <div class="text-center mx-2" style="height:20px; width: 50px; background-color: #eeeeee;">
                                      {{ menu.Qty }}
                                    </div>
                                    <button 
                                    v-on:click="onclickMinus(menu.Id)"  
                                    class="d-flex align-center border-0" 
                                    style="height:20px; width: 34px;"
                                    >-</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-5" style="text-align: right;margin: auto;">
                            <span class="title" style="font-weight: bold;font-size: 16px;margin-right:15px;">
                              ${{ menu.Price }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
                <!-- <div class="paymentSummary" style="max-height: 40%;height: 40%; overflow: auto;">
                  
                </div> -->
                <div class="card m-2"
                  style="border: none;background-color: rgb(228, 229, 230);margin-bottom: 0px !important;">
                  <div class="card-body">
                    <div class="row card-text">
                      <div class="col-6">{{ $t('Sub Total') }}</div>
                      <div class="col-6" style="text-align: right;">{{ paymentSummary.total.toFixed(2) }}</div>
                    </div>
                    <div class="row card-text">
                      <div class="col-6">{{ $t('Tax') }}</div>
                      <div class="col-6" style="text-align: right;">$ {{ paymentSummary.tax.toFixed(2) }}</div>
                    </div>
                    <hr style="border-style: dashed;">
                    <div class="row card-text">
                      <div class="col-6">{{ $t('Payment') }}</div>
                      <div class="col-6" style="text-align: right;">$ {{ paymentSummary.totalPayment.toFixed(2) }}</div>
                    </div>
                    <div class="row mt-3" style="background-color: white;">
                      <div class="col-6" style="padding: 0px;">
                        <div
                          :class="(paymentTerm.payLater) ? 'card paymentTermBtn paymentTermBtnActive' : 'card paymentTermBtn'"
                          v-on:click="clickOnPayment('payLater')"
                          style="margin: auto;vertical-align: middle;border: none; padding: 5px;">
                          <i class="fa fa-file-text fa-1x" style="margin: auto;"></i> <!--font-size: 25px;-->
                          <div class="card-text" style="font-size: 10px;text-align: center;">
                            Paylater
                          </div>
                        </div>
                      </div>
                      <div class="col-6" style="padding: 0px;">
                        <div
                          :class="(paymentTerm.cashPayout) ? 'card paymentTermBtn paymentTermBtnActive' : 'card paymentTermBtn'"
                          v-on:click="clickOnPayment('cashPayout')"
                          style="margin: auto;vertical-align: middle;border: none; padding: 5px;">
                          <i class="fa fa-usd fa-1x" style="margin: auto;"></i> <!--font-size: 25px;-->
                          <div class="card-text" style="text-align: center;font-size: 10px;">
                            Cash Payout
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-info mt-2" v-on:click="confirmTransaction"
                  style="margin: auto;width: 95%; margin-bottom: 0px;color: white;">{{ $t('Place An Order') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Swal from 'sweetalert2';
  import VueSlickCarousel from 'vue-slick-carousel'
  import CustomerDropdown from "../Customer/Dropdown.vue";
  import { ToWords } from 'to-words';
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  
  export default {
    components: {
      // SearchMenu,
      VueSlickCarousel,
      CustomerDropdown,
    },
    data: () => ({
      isAllCategory: true,
      list_categories: [],
      listMenu: [],
      listMenuSelected: [],
      searchMenu: '',
      customerId: "",
      customerName: "",
      paymentSummary: {
        total: 0,
        tax: 0,
        totalPayment: 0,
        height: "",
        heightTotalPayment: "",
      },
      paymentTerm: {
        // credit_Card: false,
        payLater: false,
        cashPayout: false,
      },
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        infinite: false,
        speed: 500,
        // "swipeToSlide": true,
      },
      exchangeRate: 4000
    }),
    async mounted() {
      var loading =this.$loading.show();
      await this.fetchCategory();
      await this.fetchItemData();
      await this.fetchGeneralCustomer();
      await this.fetchExchangeRate();
      await this.onLoad(-99);
      this.$refs.customerDropdown.init();
      this.paymentSummary.height = "max-height: " + (screen.height - (screen.height * 0.0)) + "px;height: " + (screen.height - (screen.height * 0.33)) + "px;overflow-x: scroll;margin-top: 20px;";
      this.paymentSummary.heightTotalPayment = "max-height: 50%;height: " + (screen.height - (screen.height * 0.62)) + "px;max-width: 120%;overflow-y: scroll;overflow-x: hidden;";
      await loading.hide();
    },
    methods: {
      fetchGeneralCustomer() {
        this.$api().post('pos/get-general-customers', {CompanyId: this.$store.state.company.Id}).then((res) => {
          if (this.$isValid(res)) {          
            this.customerId = res.data.Json.GeneralCustomer.Id;            
            this.customerName = res.data.Json.GeneralCustomer.NameEng;
          }
        })
      },
      onclickActiveCard(index) {
        this.list_categories.filter(function (obj) {
          if (obj.Id == index) {
            obj.Active = true;
          } else {
            obj.Active = false;
          }
        });
        this.isAllCategory = false;
        this.onLoad(index);
      },
      onLoad(index) {
        if (index == -99) {
          this.isAllCategory = true;
          this.list_categories.map((obj) => obj.Active = false);
          this.listMenuSelected = this.listMenu.filter(function (obj) {
            (obj.Qty > 0) ? obj.Qty : obj.Qty = 0;
            return obj
          });
          return;
        }
        this.listMenuSelected = this.listMenu.filter(function (obj) {
          if (!obj.hasOwnProperty('Qty')) obj.Qty = 0;
          return obj.CategoryId === index
        })
      },
      onclickAdd(index) {
        let summary = this.paymentSummary;
        this.listMenuSelected = this.listMenu.filter(function (obj) {
          if (!obj.hasOwnProperty('Qty')) obj.Qty = 0;
          if (obj.Id == index) {
            obj.Qty = parseFloat(obj.Qty) + 1;
            summary.total += parseFloat(obj.Price);
            let tax = 0;            
            if(obj.IncludeTax == 1) tax = obj.Price * 0.1
            summary.tax += tax;           
            summary.totalPayment += obj.Price + tax;
          }
        });
        this.paymentSummary = summary;
        if (this.list_categories.find(d => d.Active === true) != undefined) {
          this.list_categories.filter((item) => {
            return (item.Active === true ? this.onLoad(item.Id) : 1);
          });
        } else {
          this.onLoad(-99);
        }
      },
      onclickMinus(index) {
        let summary = this.paymentSummary;
        this.listMenuSelected = this.listMenu.filter(function (obj) {
          if (obj.Id == index && obj.Qty > 0) {
            if (!obj.hasOwnProperty('Qty')) obj.Qty = 0;
            obj.Qty = obj.Qty - 1;
            summary.total -= parseFloat(obj.Price);
            summary.tax -= (obj.Price * 0.1);
            summary.totalPayment -= (obj.Price + obj.Price * 0.1);
          }
          return;
        });
        this.paymentSummary = summary;
        if (this.list_categories.find(d => d.Active === true) != undefined) {
          this.list_categories.filter((item) => {
            return (item.Active === true ? this.onLoad(item.Id) : 1);
          });
        } else {
          this.onLoad(-99);
        }
      },
      fetchCategory() {
        let query = {
          Text: '',
          Page: 1,
          Total: 0,
          Limit: 99999,
          CompanyId: this.$store.state.company.Id
        };
        this.$api().post('pos/get-categories', query).then((res) => {
          if (this.$isValid(res)) {
            this.list_categories = res.data.Data;
          }
        })
      },
      async fetchItemData() {
        let query = {
          CompanyId: this.$store.state.company.Id,
        };
        await this.$api().post('pos/get-items', query).then((res) => {
          if (this.$isValid(res)) {
            this.listMenu = res.data.Data;            
          }
        })
      },
      currentDate() {
        const current = new Date();
        const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
        return date;
      },
      clickOnPayment(type) {
        //this.paymentTerm.filter((item) => (item.hasOwnProperty("creditCard"))?console.log("Hello"):console.log("Hell"))
        this.paymentTerm = {
          credit_Card: false,
          payLater: false,
          cashPayout: false,
        };
        this.paymentTerm[type] = true;
      },
      SearchItem(e) {
        this.listMenuSelected = this.listMenu.filter(function (obj) { return obj.Name.includes(e.target.value) || obj.Num.includes(e.target.value) ; });
      },
      ClearDataForm() {
        this.paymentSummary.total = 0;
        this.paymentSummary.tax = 0;
        this.paymentSummary.totalPayment = 0;
        this.paymentTerm.credit_Card = false;
        this.paymentTerm.payLater = false;
        this.paymentTerm.cashPayout = false;
        this.listMenu.filter(function (obj) { obj.Qty = 0; obj.Active = false; return obj; });
        this.list_categories.filter(function (obj) { obj.Active = false; });
        this.onLoad(-99);
      },
      confirmTransaction() {
        Swal.fire({
          title: 'Are you sure?',
          text: "Please click to add transaction",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, added'
        }).then((result) => {
          if (result.value) {
            let payment_term = "Cash Payout";
            if(this.paymentTerm.payLater) payment_term = "Pay Later";
            const current = new Date();
            const currentDate = `${current.getFullYear()}/${current.getMonth() + 1}/${current.getDate()}`;
            let lines = [];
            const headerInvoice = {
              CustomerId: this.customerId,
              Date: currentDate,
              DateCreated: currentDate,
              CompanyId: this.$store.state.company.Id,
              ClientId: this.$store.state.company.ClientId,
              CreatedBy: "",
              InvoiceType: "COMERCIAL",
              IsApproved: false,            
              Status: "Draft",
              TaxVat: this.paymentSummary.tax,
              TotalAmount: this.paymentSummary.totalPayment,
              IncludeTaxAmount: this.paymentSummary.totalPayment,
              GrandTotal: this.paymentSummary.total,
              Balance: this.paymentSummary.totalPayment,
              PaymentTerm: payment_term,
              ExchangeRate: this.exchangeRate
            };
            this.listMenu.map(e => {
              if(e.Qty > 0) {
                lines.push({
                  Cost: e.Cost,
                  Description: e.Name,                
                  ExchangeRate: this.exchangeRate,
                  ItemId: e.Id,
                  ItemName: e.Name,
                  Price: e.Price,
                  Quantity: e.Qty,
                  SubTotal: e.Price * e.Qty,
                  TaxAmount: e.Price * e.Qty * 0.1,
                  TaxLine: 10
                });
              }
            });
  
            const headerReceipt = {
              AccountId: "da614d0b-531d-4e24-b26f-3a8cd950de3f",            
              ClientId: this.$store.state.company.ClientId,
              CompanyId: this.$store.state.company.Id,
              CustomerId: this.customerId,
              Amount: this.paymentSummary.totalPayment,
              Date: currentDate,              
              TextAmount: this.toTextAmount(this.paymentSummary.totalPayment),
            };
  
            const linesReceipt = [{
              Balance: this.paymentSummary.totalPayment,
              InvoiceDate: currentDate,
              InvoiceDueDate: currentDate,
              OriginalAmount: this.paymentSummary.totalPayment,
              ReceiveAmount: this.paymentSummary.totalPayment,
              TaxNum: 10,
            }];
  
            const req = {
              HeaderInvoice: headerInvoice,
              LinesInvoice: lines,
              HeaderReceipt: headerReceipt,
              LinesReceipt: linesReceipt,
            };          
            const loading = this.$loading.show();
            this.$api()
              .post("pos/save", req)
              .then((res) => {
                if (this.$isValid(res)) {
                  this.$swal.fire("Success", "Add success.", "success");
                  this.ClearDataForm();
                }
              })
              .finally(() => {
                loading.hide();
              });
          }
        });
      },
      customerSelected(item) {
        if (item.type == 3) {
          this.customerName = item.data.Name;
          this.customerId = item.data.Id;
        }
      },
      toTextAmount(amount){
        const toWords = new ToWords({localeCode: 'en-US'});
        return toWords.convert(amount, { currency: true });
      },
      fetchExchangeRate() {
        let req = {
          "CompanyId": this.$store.state.company.Id
        };
        this.$api()
          .post("invoice/exchangerate-by-date", req)
          .then((res) => {
            if (this.$isValid(res)) {
              if (res.data.Json.Rate) this.exchangeRate = res.data.Json.Rate.Value;  
            }
        });
      },
    }
  };
  </script>

<style scoped>
  .w-h-25 {
    width: 50px;
    height: 50px;
  }

  .d-flex {
    display: flex;
  }

  .gap-2 {
    gap: 0.1rem; /* Adjust gap as needed */
  }

  .justify-center {
    justify-content: center;
  }

  .flex-column {
    flex-direction: column;
  }

  .bg-white {
    background-color: white;
  }

  .rounded-lg {
    border-radius: 8px; /* Adjust radius for smoother corners */
  }

  .mb-3 {
    margin-bottom: 1rem;
  }

  .p-2 {
    padding: 0.5rem;
  }

  .img-thumbnail {
    border-radius: 8px;
    object-fit: cover; /* Keeps image aspect ratio */
  }

  .text-center {
    text-align: center;
  }

  .title {
    font-size: 1rem; /* Adjust size for better readability */
    font-weight: bold;
    margin-bottom: 0.1rem; /* Reduce spacing below title */
  }

  .col-5 {
    flex: 0 0 auto;
    max-width: 40%; /* Restrict column width */
    padding: 0;
  }

  .col-md-5, .col-lg-5 {
    max-width: 40%; /* Same as above for larger screens */
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 24px; /* Increased height for better touch usability */
    width: 34px;
  }

  button:focus {
    outline: none;
  }

  button:active {
    transform: scale(0.95); /* Adds subtle click animation */
  }

  button.plus {
    background-color: #00406b;
    color: white;
  }

  button.minus {
    background-color: #ccc; /* Neutral color for minus button */
  }

  .mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .custom-slick .slick-slide {
    width: 100% !important;
  }

  .qty-display {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eeeeee;
    height: 24px;
    width: 50px;
    font-size: 0.9rem; /* Adjust font size */
    border-radius: 4px;
  }
</style>